module.exports = {
  createCompany: '会社を作る',
  createCatalog: 'カタログを作成する',
  edit: '編集',
  activate: '活性化する',
  deactivate: '非アクティブ化する',
  cancel: 'キャンセル',
  create: '作成する',
  update: '更新',
  submit: '提出する',
};



// WEBPACK FOOTER //
// ./src/lang/ja/actions.js